import { useCandidateHeaderQuery } from "@generated/graphql";
import ExaminationList from "components/ExaminationList";
import qs from "qs";
import { useParams } from "react-router-dom";
import columnConfig from "./tableConfig/columnConfig";

const TrialList = () => {
  const { candidateId } = useParams();

  const { data: candidateData } = useCandidateHeaderQuery({ variables: { candidateId: candidateId! } });

  const permanentFilter = {
    candidateNumericId: candidateData?.companyCandidate?.numericId,
  };

  return (
    <ExaminationList
      storageName='candidateTesting'
      permanentFilter={permanentFilter}
      columnsConfig={columnConfig}
      defaultVisibleColumnList={[
        "numericId",
        "competencyMapTitle",
        "competencesCount",
        "candidateNumericId",
        "candidate",
        "createdAt",
        "status",
        "type",
        "reminderSend",
      ]}
      navigateSearch={qs.stringify({ candidateId })}
    />
  );
};

export default TrialList;
